var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addresses-container"},[_c('Address',{attrs:{"user":_vm.user,"show-colon-after-label":_vm.showColonAfterLabel,"label-mode":_vm.labelMode,"label-location":_vm.labelLocation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }